/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paywall_Exclusive_FilesvideosInputs */

const en_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paywall exclusive files/videos`)
};

const es_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos/videos exclusivos tras muro de pago`)
};

const fr_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichiers/vidéos exclusifs avec paywall`)
};

const de_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paywall für exklusive Dateien/Videos`)
};

const ja_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限定ファイル/ビデオのペイウォール化`)
};

const zh_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付费独家文件/视频`)
};

const ar_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملفات/فيديوهات حصرية مدفوعة`)
};

const id_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batasi akses file/video (Paywall)`)
};

const it_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paywall per file/video esclusivi`)
};

const ru_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платный доступ к эксклюзивным файлам/видео`)
};

const pt_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paywall de arquivos/vídeos exclusivos`)
};

const ko_paywall_exclusive_filesvideos = /** @type {(inputs: Paywall_Exclusive_FilesvideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이월 독점 파일/비디오`)
};

/**
* | output |
* | --- |
* | "Paywall exclusive files/videos" |
*
* @param {Paywall_Exclusive_FilesvideosInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const paywall_exclusive_filesvideos = /** @type {((inputs?: Paywall_Exclusive_FilesvideosInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paywall_Exclusive_FilesvideosInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_paywall_exclusive_filesvideos(inputs)
	if (locale === "es") return es_paywall_exclusive_filesvideos(inputs)
	if (locale === "fr") return fr_paywall_exclusive_filesvideos(inputs)
	if (locale === "de") return de_paywall_exclusive_filesvideos(inputs)
	if (locale === "ja") return ja_paywall_exclusive_filesvideos(inputs)
	if (locale === "zh") return zh_paywall_exclusive_filesvideos(inputs)
	if (locale === "ar") return ar_paywall_exclusive_filesvideos(inputs)
	if (locale === "id") return id_paywall_exclusive_filesvideos(inputs)
	if (locale === "it") return it_paywall_exclusive_filesvideos(inputs)
	if (locale === "ru") return ru_paywall_exclusive_filesvideos(inputs)
	if (locale === "pt") return pt_paywall_exclusive_filesvideos(inputs)
	return ko_paywall_exclusive_filesvideos(inputs)
});